import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Provider } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "./components/AdminLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import AnalyticsPage from "./pages/AnalyticsPage";
import DashboardPage from "./pages/DashboardPage";
import DeletionRequestsPage from "./pages/DeletionRequestsPage";
import DiagnosticsPage from "./pages/DiagnosticsPage";
import LoginPage from "./pages/LoginPage";
import PromoCodesPage from "./pages/PromoCodesPage";
import SettingsPage from "./pages/SettingsPage";
import SubscriptionPlansPage from "./pages/SubscriptionPlansPage";
import TextDetailPage from "./pages/TextDetailPage";
import TextQualityPage from "./pages/TextQualityPage";
import TextsPage from "./pages/TextsPage";
import UserDetailPage from "./pages/UserDetailPage";
import UsersPage from "./pages/UsersPage";
import VoicesPage from "./pages/VoicesPage";
import { store } from "./store";

import type { ReactElement } from "react";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

const AppContent: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<ProtectedRoute />}>
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:userId" element={<UserDetailPage />} />
          <Route path="texts" element={<TextsPage />} />
          <Route path="text-quality" element={<TextQualityPage />} />
          <Route path="text-quality/:textId" element={<TextQualityPage />} />
          <Route path="texts/:textId" element={<TextDetailPage />} />
          <Route path="voices" element={<VoicesPage />} />
          <Route
            path="subscription-plans"
            element={<SubscriptionPlansPage />}
          />
          <Route path="deletions" element={<DeletionRequestsPage />} />
          <Route path="promo-codes" element={<PromoCodesPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="diagnostics" element={<DiagnosticsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

function App(): ReactElement {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppContent />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
